import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e8b1e764")

_pushScopeId("data-v-e8b1e764")
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "conversation-escalated-blurb"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_messages_stream = _resolveComponent("messages-stream")
  const _component_messages_keyboard = _resolveComponent("messages-keyboard")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("header", _hoisted_2, [
      _createVNode("h2", {
        textContent: `Chat with ${_ctx.customerName}`
      }, null, 8, ["textContent"]),
      (_ctx.conversationInfo && !_ctx.conversationInfo?.isEscalated)
        ? (_openBlock(), _createBlock(_component_ion_button, {
            key: 0,
            size: "small",
            fill: "solid",
            color: "danger",
            innerHTML: _ctx.gxButton,
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.escalateToGX(_ctx.referenceNumber)))
          }, null, 8, ["innerHTML"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_messages_stream, {
      "message-groups": _ctx.groupedMessages,
      "first-new-group": _ctx.firstNewGroup,
      "in-name": "&pizza",
      "out-name": _ctx.customerName,
      "show-dates": false,
      "show-store-name": false
    }, null, 8, ["message-groups", "first-new-group", "out-name"]),
    _createVNode("footer", null, [
      (_ctx.conversationInfo?.isEscalated)
        ? (_openBlock(), _createBlock("span", _hoisted_3, "Conversation escalated to GX"))
        : _createCommentVNode("", true),
      _createVNode(_component_messages_keyboard, {
        "onSend-message": _cache[2] || (_cache[2] = $event => (_ctx.sendCustomerMessage($event, _ctx.orderId, _ctx.referenceNumber)))
      })
    ])
  ]))
})